// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TDeclineRealEstateRequest,
  TDeclineRealEstateModel,
  IMappers,
  TDeclineRealEstateResponse,
  TDeclineRealEstateResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createDeclineRealEstateModel(parameters: TDeclineRealEstateRequest): TDeclineRealEstateModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cian-dobro',
    pathApi: '/v1/decline-real-estate/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IDeclineRealEstateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TDeclineRealEstateRequest;
}

export async function fetchDeclineRealEstate<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDeclineRealEstateOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDeclineRealEstateResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDeclineRealEstateModel(parameters),
    config,
  )) as FetchResponse<TDeclineRealEstateResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TDeclineRealEstateResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDeclineRealEstateResponse>;
}
